export default "__VITE_ASSET__367d4c92__"